import { createSlice } from "@reduxjs/toolkit";
import { sendNotification } from "./utils/PushNotifUtils";

const initialState = {
  title: "",
  body: "",
  image: "",
  topics: [],
  link: "",
  token: "",
  scheduled_at: "",
  analytics_label: "",
  isLoading: false
};

const addPushNotif = createSlice({
  name: "addPushNotif",
  initialState: initialState,
  reducers: {
    setField: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
      console.log(field, value);
    },
    resetState: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNotification.pending, (state) => {
        // Handle loading state
        state.isLoading = true;
      })
      .addCase(sendNotification.fulfilled, (state, action) => {
        // Handle success state
        state.isLoading = false;
      })
      .addCase(sendNotification.rejected, (state, action) => {
        // Handle error state
        console.log(action.error.message, "error action");
        state.isLoading = false;
      });
  },
});

export const { setField, resetState } = addPushNotif.actions;

export default addPushNotif.reducer;
